import type { ReactElement } from 'react'
import { ImgGlyph } from './ImgGlyph'
import type { GlyphProps } from './shared'

// Base Mantis silhouette uses the ★1 tier art. The active rendering
// for Mantis Acolyte goes through TIERED_GLYPHS (see tieredGlyphs.ts)
// which routes ★2/★3 to the richer tier images extracted from
// assets/mantis_3tier.jpg.
export const Mantis = ({ size = 110 }: GlyphProps): ReactElement => (
  <ImgGlyph src="/glyph-assets/mantis-1.png" size={size} alt="mantis" />
)
